export const BAR_WIDTHS = ['100%', '93%', '75%', '60%', '54%', '45%', '30%', '10%']
